<template>
    <div>
           <div class="about-banner">
                <img src="../../static/img/zhaopin.png" />
                <div class="about-banner-word">
                    <span>人才招聘 Talent Recruitment</span>
                    <img src="img/fb.png" />
                </div>
            </div>
            <div class="about-title">
                <span class="fn32">招聘岗位 </span>
            </div>
            <div class="employ-box">
                <div class="employ-list" v-for="(item,index) in tableData" :key='index'>
                    <h3>{{item.position_name}}</h3>
                    <div class="employ-info">
                        <span>{{position_type}}</span>
                        <span>{{item.word_place}}</span>
                        <span>招聘人数：{{item.number}}人</span>
                    </div>
                    <div class="employ-date">
                        <span>{{item.addtime}}</span>
                        <a href="javascript:;" @click="toDetail(item.position_id)">了解详情</a>
                    </div>
                </div>
            </div>
            <!-- <a class="loading-more">加载中...</a>  -->
    </div>
</template>
<style scoped>

</style>
<script>
export default {
        name: 'Recruit',
        data () {
            return {
                menu_active: [
                    {
                        title: '招聘岗位',
                        link: '',
                        isActive: true,
                    },
                ],
                active: false,
                // activeName: '1',
                index:0,
                tableData: '',
            }
        },
        mounted(){
            this.baseUrl = window.baseUrl;
            this.config = window.config;
            this.recruitment();
        },
        methods:{
            show:function(j){
                this.index = j;
                console.log(this.index)
            },
            recruitment: function(){
                var that = this;
                //招聘岗位
                that.$http.post(that.baseUrl+that.config.recruitment).then(function(ev){
                    console.log(ev);
                    if(ev.data.code == 100){
                        that.tableData = ev.data.data;
                    }
                }).catch(function(error){
                    console.log(error)
                })
            },
            toDetail: function(id){
                this.$router.push({
                    name: 'RecruitDetail',
                    params: {
                        id: id
                    }
                })
            }
        },
        created(){

        },
    }
</script>


// WEBPACK FOOTER //
// src/pages/Recruit.vue